export default "__VITE_ASSET__761670a6__"